import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MapPin, Hotel, Globe } from "lucide-react";
import { Users } from "lucide-react";
import { useRef } from "react";
import { DateRange } from "react-date-range";
import { Search } from "lucide-react";
import { Calendar } from "lucide-react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";



function SearchBar() {
  const [destination, setDestination] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [showGuests, setShowGuests] = useState(false);
  const [destinationError, setDestinationError] = useState(false);

  const formatDate = (date) =>
    date.toLocaleDateString("fr-FR", {
      weekday: "short", // ou "long"
      day: "numeric",
      month: "short",
    });

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const [dateRange, setDateRange] = useState([
    {
      startDate: today,
      endDate: tomorrow,
      key: "selection",
    },
  ]);

  const [isSelecting, setIsSelecting] = useState(false);

  const formatAPIDate = (date) =>
    new Date(date).toLocaleDateString("sv-SE");

  const checkIn = formatAPIDate(dateRange[0].startDate);
  const checkOut = formatAPIDate(dateRange[0].endDate);
  const [showCalendar, setShowCalendar] = useState(false);
  const isInvalid =
    !dateRange[0].startDate ||
    !dateRange[0].endDate ||
    dateRange[0].endDate <= dateRange[0].startDate;

  const navigate = useNavigate();
  const guestsRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (guestsRef.current && !guestsRef.current.contains(e.target)) {
        setShowGuests(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const calendarRef = useRef();
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getIcon = (item) => {
    if (item.name) return <Hotel size={16} className="text-gray-500" />;
    if (item.city) return <MapPin size={16} className="text-gray-500" />;
    return <Globe size={16} className="text-gray-500" />;
  };

  const getLabel = (item) => {
    if (item.name) return item.name;
    if (item.city) return item.city;
    return item.island;
  };

  const getSubLabel = (item) => {
    if (item.name) return item.city;
    if (item.city) return item.island;
    return "";
  };
  const Item = ({ item }) => (
    <div
      onClick={() => {
        setIsSelecting(true); // 🔥 important
        setDestination(item.name || item.city || item.island);
        setOpen(false);
      }}
      className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer"
    >
      <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg">
        {getIcon(item)}
      </div>

      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-900">
          {getLabel(item)}
        </span>
        <span className="text-xs text-gray-500">
          {getSubLabel(item)}
        </span>
      </div>
    </div>
  );

  // 🔥 autocomplete
  useEffect(() => {
    if (isSelecting) {
      setIsSelecting(false);
      return;
    }

    if (!destination) {
      setResults([]);
      return;
    }

    const delayDebounce = setTimeout(async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/hotels/search-suggestions`,
          {
            params: { destination }
          }
        );
        setResults(res.data);
        setOpen(true);
      } catch (err) {
        console.log(err);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [destination]);
  const hotels = results.filter(r => r.name);
  const cities = results.filter(r => !r.name && r.city);
  const islands = results.filter(r => !r.name && !r.city && r.island);

  useEffect(() => {
  if (destination) {
    setDestinationError(false);
  }
}, [destination]);

  // 🔥 search submit
  const handleSearch = () => {
    if (!destination) {
      setDestinationError(true);
      return;
    }

    setDestinationError(false);

    if (isInvalid) {
      setShowCalendar(true); // 🔥 ouvre direct
      return;
    }
    const totalGuests = adults + children;

    navigate(
      `/hotels?destination=${destination}&checkIn=${checkIn}&checkOut=${checkOut}&guests=${totalGuests}`
    );
  };

  return (
    <div className="mt-10 w-full max-w-6xl relative">

      <div className="rounded-2xl bg-white p-4 shadow-xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

          {/* DESTINATION */}
          <div className="relative">
  
            {/* INPUT */}
            <input
              type="text"
              placeholder="Destination"
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
              onFocus={() => setOpen(true)}
              className={`
                w-full rounded-xl border border-gray-300
                pl-10 pr-10 py-3
                focus:outline-none focus:ring-2 focus:ring-[#3A9D23]
                ${
                  destinationError
                    ? "border-red-400 bg-red-50 focus:ring-red-400"
                    : "border-gray-300 focus:ring-[#3A9D23]"
                }
              `}
            />

            {/* ICON */}
            <Search
              size={16}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            {/* ❌ bouton clear */}
            {destination && (
              <button
                onClick={() => setDestination("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            )}

            {/* 🔥 TOOLTIP ERROR */}
            <div
              className={`
                absolute bottom-full left-0 mb-2
                transition-all duration-200
                ${
                  destinationError
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-1 pointer-events-none"
                }
              `}
            >
              <div className="bg-red-500 text-white text-xs px-3 py-2 rounded-lg shadow-lg whitespace-nowrap">
                Veuillez entrer une destination
              </div>

              {/* petite flèche */}
              <div className="w-2 h-2 bg-red-500 rotate-45 ml-3 mt-[-4px]"></div>
            </div>


            {/* 🔥 DROPDOWN */}
            {open && results.length > 0 && (
              <div className="
                    absolute bottom-full left-0 w-full mb-2
                    bg-white border rounded-2xl shadow-xl z-50
                    overflow-hidden
                    max-h-64 overflow-y-auto
                    ">

                {/* HOTELS */}
                {hotels.length > 0 && (
                  <>
                    <div className="px-4 py-2 text-xs text-gray-400 font-semibold">
                      Hôtels
                    </div>
                    {hotels.map((item) => (
                      <Item key={item._id} item={item} />
                    ))}
                  </>
                )}

                {/* CITIES */}
                {cities.length > 0 && (
                  <>
                    <div className="px-4 py-2 text-xs text-gray-400 font-semibold">
                      Villes
                    </div>
                    {cities.map((item) => (
                      <Item key={item._id} item={item} />
                    ))}
                  </>
                )}

                {/* ISLANDS */}
                {islands.length > 0 && (
                  <>
                    <div className="px-4 py-2 text-xs text-gray-400 font-semibold">
                      Îles
                    </div>
                    {islands.map((item) => (
                      <Item key={item._id} item={item} />
                    ))}
                  </>
                )}

              </div>
            )}
          </div>



          {/* DATES PREMIUM */}
          <div className="relative md:col-span-1" ref={calendarRef}>

            {/* INPUT */}
            <div
              onClick={() => setShowCalendar(!showCalendar)}
              className="w-full rounded-xl border border-gray-300 px-4 py-3 cursor-pointer flex items-center justify-between hover:border-gray-400"
            >
              {/* LEFT (icon + text) */}
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <Calendar size={16} className="text-gray-400" />
                <span>
                  {formatDate(dateRange[0].startDate)} → {formatDate(dateRange[0].endDate)}
                </span>
              </div>

              {/* RIGHT arrow */}
              <span className={`text-gray-400 transition ${showCalendar ? "rotate-180" : ""}`}>
                ▾
              </span>
            </div>

            {/* CALENDAR */}
            <div
              className={`
              absolute bottom-full mb-3 z-50 bg-white rounded-2xl shadow-xl
              transition-all duration-200
              ${showCalendar ? "opacity-100" : "opacity-0 pointer-events-none"}
            `}
            >
              <DateRange
                editableDateInputs={true}
                onChange={(item) => setDateRange([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={dateRange}
                minDate={new Date()}
                rangeColors={["#3A9D23"]}
              />
            </div>
          </div>
          {/* GUESTS */}
          <div className="relative" ref={guestsRef}>
            {/* INPUT */}
            <div
              onClick={() => setShowGuests(!showGuests)}
              className="w-full rounded-xl border border-gray-300 px-4 py-3 cursor-pointer flex items-center justify-between hover:border-gray-400 transition"
            >
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <Users size={16} />
                <span>
                  {adults} adulte{adults > 1 ? "s" : ""} · {children} enfant{children > 1 ? "s" : ""}
                </span>
              </div>
              <span className={`text-gray-400 transition ${showGuests ? "rotate-180" : ""}`}>
                ▾
              </span>
            </div>

            {/* DROPDOWN */}
            <div
              className={`
              absolute bottom-full mb-2 w-full bg-white border rounded-2xl shadow-xl p-4 z-50
              transition-all duration-200
              ${showGuests ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
            `}
            >
              {/* ADULTS */}
              <div className="flex justify-between items-center mb-4">
                <div>
                  <p className="text-sm font-medium">Adultes</p>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setAdults(Math.max(1, adults - 1))}
                    className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-gray-100"
                  >
                    -
                  </button>

                  <span className="w-4 text-center">{adults}</span>

                  <button
                    onClick={() => setAdults(adults + 1)}
                    className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-gray-100"
                  >
                    +
                  </button>
                </div>
              </div>

              {/* CHILDREN */}
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium">Enfants</p>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setChildren(Math.max(0, children - 1))}
                    className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-gray-100"
                  >
                    -
                  </button>

                  <span className="w-4 text-center">{children}</span>

                  <button
                    onClick={() => setChildren(children + 1)}
                    className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-gray-100"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* BUTTON */}
          <div className="relative group w-full">
            <button
              onClick={handleSearch}
              className="
                w-full rounded-xl py-3 font-semibold text-white
                bg-[#3A9D23]
                disabled:opacity-60 disabled:cursor-not-allowed
                transition
              "
            >
              Rechercher
            </button>

            {/* TOOLTIP */}
            {isInvalid && (
              <div
                className="
                  absolute bottom-full mb-2 left-1/2 -translate-x-1/2
                  bg-black text-white text-xs px-3 py-2 rounded-lg
                  opacity-0 group-hover:opacity-100
                  transition pointer-events-none whitespace-nowrap
                "
              >
                Sélectionne des dates valides
              </div>
            )}
          </div>

        </div>
      </div>

    </div>
  );
}

export default SearchBar;